import React, { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { CURRENCIES, PLANS } from "../mock";

export default function Pricing() {
  const [cur, setCur] = useState("USD");
  const c = CURRENCIES[cur];

  const fmt = (n) => c.symbol + n.toLocaleString("en-US");

  return (
    <section id="pricing" style={{ padding: "72px 0", background: "var(--paper-2)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <Reveal>
            <div>
              <div className="section-label">Pricing · three plans, no setup fee</div>
              <h2 className="h-section" style={{ marginTop: 18, maxWidth: 620 }}>
                Priced by market. <span className="serif" style={{ fontSize: "1.05em" }}>Not by seat.</span>
              </h2>
              <p style={{ marginTop: 18, fontSize: 16, color: "var(--ink-soft)", maxWidth: 520 }}>
                Every plan includes infrastructure, lists, copy, sending and a monthly report.
              </p>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <div className="flex" style={{ border: "1px solid var(--line-strong)", borderRadius: 3, overflow: "hidden" }}>
              {Object.keys(CURRENCIES).map((k) => (
                <button
                  key={k}
                  onClick={() => setCur(k)}
                  className="mono"
                  style={{
                    padding: "9px 16px",
                    fontSize: 13,
                    fontWeight: 600,
                    background: cur === k ? "var(--ink)" : "transparent",
                    color: cur === k ? "var(--paper)" : "var(--ink-soft)",
                    borderRight: k !== "INR" ? "1px solid var(--line)" : "none",
                    transition: "background 0.2s ease, color 0.2s ease",
                  }}
                >
                  {k}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-5" style={{ marginTop: 44 }}>
          {PLANS.map((p, i) => {
            const featured = !!p.tag;
            return (
              <Reveal key={p.name} delay={i * 90}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 5,
                    padding: "30px 26px",
                    background: featured ? "var(--ink)" : "var(--card)",
                    color: featured ? "var(--paper)" : "var(--ink)",
                    border: `1px solid ${featured ? "var(--ink)" : "var(--line)"}`,
                    boxShadow: featured ? "0 24px 60px -30px rgba(27,26,21,0.6)" : "none",
                  }}
                >
                  <div className="flex items-center justify-between">
                    <span style={{ fontSize: 15, fontWeight: 600 }}>{p.name}</span>
                    {p.tag && (
                      <span style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.1em", background: "var(--accent)", color: "#fff", padding: "4px 9px", borderRadius: 99 }}>{p.tag}</span>
                    )}
                  </div>

                  <div style={{ marginTop: 20, display: "flex", alignItems: "baseline", gap: 4 }}>
                    <span style={{ fontSize: 40, fontWeight: 600, letterSpacing: "-0.02em" }}>{fmt(c.rates[i])}</span>
                    <span style={{ fontSize: 15, opacity: 0.7 }}>/mo</span>
                  </div>
                  <div style={{ fontSize: 13, marginTop: 4, opacity: 0.7 }}>{p.minimum}</div>

                  <ul style={{ marginTop: 22, display: "flex", flexDirection: "column", gap: 12, flex: 1 }}>
                    {p.features.map((f, fi) => (
                      <li key={fi} className="flex items-start gap-2.5" style={{ fontSize: 14, lineHeight: 1.5 }}>
                        <Check size={16} style={{ marginTop: 2, flexShrink: 0, color: featured ? "#7dd3fc" : "var(--accent)" }} />
                        <span style={{ opacity: featured ? 0.92 : 1 }}>{f}</span>
                      </li>
                    ))}
                  </ul>

                  <div style={{ marginTop: 22, fontSize: 13, opacity: 0.68 }}>{p.footer}</div>
                  <a
                    href="#apply"
                    className="btn"
                    style={{
                      marginTop: 16,
                      justifyContent: "center",
                      background: featured ? "#ffffff" : "var(--accent)",
                      color: featured ? "var(--ink)" : "#ffffff",
                    }}
                  >
                    Apply for {p.name} <ArrowRight size={15} />
                  </a>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={120}>
          <p style={{ marginTop: 28, fontSize: 13.5, lineHeight: 1.7, color: "var(--ink-soft)", maxWidth: 900 }}>
            Invoiced monthly in advance; pay a quarter up front for 5% off. First emails go out in week three, after
            inbox warm-up. No meeting guarantees: we commit to the work, report monthly, and you can leave after three
            months. Referral partners earn 10 to 15% of fees for six months.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
